import { render } from "./CreateRelationModal.vue?vue&type=template&id=5341e69c"
import script from "./CreateRelationModal.vue?vue&type=script&lang=js"
export * from "./CreateRelationModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"CreateRelationModal.vue"]])

export default __exports__